import "./style.css";
import { h, van } from "./lib/tb.js";
import * as api from "./lib/api.js";
import { LoginView } from "./views/login.js";
import { ArticlesSection } from "./views/articles.js";
import { ImagesSection } from "./views/images.js";
import { ToastContainer } from "./lib/toast.js";

const route = van.state("loading"); // loading | login | app

function Header() {
  return h("header.header", [
    h("div.header__inner", [
      h("div", [
        h("div.text-base.font-semibold.text-slate-900", "IDENEL"),
        h("div.text-xs.text-slate-500", "Správa salonů"),
      ]),
      h("button.btn.btn-ghost.btn-sm", {
        onclick: async () => { await api.logout(); route.val = "login"; },
      }, "Odhlásit"),
    ]),
  ]);
}

function AppView() {
  return h("div", [
    Header(),
    h("main.container.py-6.lg:py-10", [
      ArticlesSection(),
      ImagesSection(),
    ]),
  ]);
}

const root = document.getElementById("app");
van.add(document.body, ToastContainer());
van.add(root, () => {
  switch(route.val) {
    case "login": return LoginView({ onSuccess: () => { route.val = "app"; } });
    case "app": return AppView();
    default: return h(".min-h-screen.grid.place-items-center.text-slate-400", "Načítám…");
  }
});

api.getSession()
  .then((s) => { route.val = s.authenticated ? "app" : "login"; })
  .catch(() => { route.val = "login"; });
